import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import Pikaday from 'pikaday'

import config from '@/config'
import { SelectInput } from '@/modules/base/components/inputs/index'
import lang from '@/lang'

const { pikaday: pikadayConfig, dateFormat: { client: clientDateFormat } } = config

const DUE_DATE_OPTIONS = Object.freeze({
  today: 'today',
  tomorrow: 'tomorrow',
  nextWeek: 'nextWeek',
  nextMonth: 'nextMonth',
  custom: 'custom',
})

const DueDateInput = React.forwardRef(function DueDateInput(props, inputRef) {
  const { label, initValue, className, onChange, customComponents, styles, dataQsId } = props
  const [value, setValue] = useState(initValue || DUE_DATE_OPTIONS.today)
  const [customDate, setCustomDate] = useState(null)

  const pikaday = useRef()
  const pikadayDivRef = useRef()

  const handleChange = (event) => {
    event.value.toString()
    setCustomDate(null)

    const dateValue = moment()

    switch (event.value) {
      case DUE_DATE_OPTIONS.tomorrow:
        dateValue.add(1, 'day')
        break
      case DUE_DATE_OPTIONS.nextWeek:
        dateValue.add(1, 'week')
        break
      case DUE_DATE_OPTIONS.nextMonth:
        dateValue.add(1, 'month')
        break
      case DUE_DATE_OPTIONS.custom:
        setValue(event.value)
        pikaday.current.show()
        return
    }

    setValue(event.value)
    onChange && onChange(dateValue.startOf('day').toDate())
  }

  const handleDaySelect = (date) => {
    const dateValue = moment(date)
    setCustomDate(dateValue)
    setValue({ value: DUE_DATE_OPTIONS.custom })
    onChange && onChange(dateValue.startOf('day').toDate())
  }

  useEffect(() => {
    pikaday.current = new Pikaday({
      ...pikadayConfig,
      field: pikadayDivRef.current,
      format: clientDateFormat,
      onSelect: handleDaySelect,
      minDate: new Date(),
    })
    return () => {
      pikaday.current.destroy()
      pikaday.current = null
    }
  }, [])

  const options = Object.keys(DUE_DATE_OPTIONS).map(key => ({
    label: key === DUE_DATE_OPTIONS.custom && customDate ? customDate.format(clientDateFormat) : lang.dueDate[key],
    value: key,
  }))

  return (
    <>
      <div ref={pikadayDivRef}></div>
      <SelectInput
        name='dueDate'
        ref={inputRef}
        label={label}
        notAsync
        dataQsId={dataQsId}
        containerClass={className}
        allowCreate={false}
        value={value}
        options={options}
        handleChange={handleChange}
        customSelectOptions={{ isSearchable: false }}
        customComponents={customComponents}
        styles={styles}
      />
    </>
  )
})

DueDateInput.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  initValue: PropTypes.oneOf(Object.values(DUE_DATE_OPTIONS)),
  onChange: PropTypes.func,
  customComponents: PropTypes.object,
  styles: PropTypes.object,
  dataQsId: PropTypes.string.isRequired,
}

export default DueDateInput
